import { render, staticRenderFns } from "./ItunesAffiliateToken.vue?vue&type=template&id=05b833de&scoped=true&"
import script from "./ItunesAffiliateToken.vue?vue&type=script&lang=js&"
export * from "./ItunesAffiliateToken.vue?vue&type=script&lang=js&"
import style0 from "./ItunesAffiliateToken.vue?vue&type=style&index=0&id=05b833de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b833de",
  null
  
)

export default component.exports